import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { getDeadlineData, getStatusUI } from '../../../utils/deadlineRules';

const { FiClock, FiAlertCircle, FiCheckCircle, FiChevronRight } = FiIcons;

// Eksporterer logikken slik at den kan brukes i andre komponenter
export const getDeadlineStatus = (report) => {
  const data = getDeadlineData(report);
  return data.status;
};

const DeadlineOverview = ({ reports = [] }) => {
  const now = new Date();

  const urgentCases = reports.filter(r => {
    const status = getDeadlineStatus(r);
    return status.startsWith('overdue') || status.startsWith('urgent') || status.startsWith('critical');
  });

  if (urgentCases.length === 0) {
    return (
      <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-green-50 text-green-600 rounded-lg">
            <SafeIcon icon={FiCheckCircle} className="text-xl" />
          </div>
          <h3 className="font-bold text-gray-900">Alle frister overholdt</h3>
        </div>
        <p className="text-sm text-gray-500">
          Ingen saker krever umiddelbar oppfølging knyttet til lovpålagte frister.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-amber-50 text-amber-600 rounded-lg">
            <SafeIcon icon={FiClock} className="text-xl" />
          </div>
          <h3 className="font-bold text-gray-900">Fristovervåking</h3>
        </div>
        <span className="px-2.5 py-1 bg-amber-100 text-amber-700 rounded-full text-xs font-bold">
          {urgentCases.length} aktive varsler
        </span>
      </div>

      <div className="space-y-4">
        {urgentCases.slice(0, 3).map(report => {
          const deadline = getDeadlineData(report);
          const ui = getStatusUI(deadline.level);
          const isOverdue = deadline.level >= 2;
          
          return (
            <div key={report.id} className={`p-4 rounded-xl border ${isOverdue ? 'bg-red-50 border-red-100' : 'bg-amber-50 border-amber-100'}`}>
              <div className="flex justify-between items-start mb-2">
                <span className="text-xs font-bold uppercase tracking-wider text-gray-500">
                  Sak: {report.id?.substring(0, 8)}
                </span>
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${isOverdue ? 'bg-red-200 text-red-800' : 'bg-amber-200 text-amber-800'}`}>
                  {ui.label}
                </span>
              </div>
              <p className="text-sm font-semibold text-gray-900 mb-1 line-clamp-1">
                {report.title || 'Uten tittel'}
              </p>
              <div className="flex items-center gap-2 text-xs text-gray-600">
                <SafeIcon icon={deadline.level >= 2 ? FiAlertCircle : FiClock} />
                <span>
                  {deadline.message}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {urgentCases.length > 3 && (
        <button className="w-full mt-4 py-2 text-sm font-bold text-blue-600 hover:bg-blue-50 rounded-lg transition-colors flex items-center justify-center gap-2">
          Se alle {urgentCases.length} varsler med frist
          <SafeIcon icon={FiChevronRight} />
        </button>
      )}
    </div>
  );
};

export default DeadlineOverview;